import { User } from "../../types";

/**
 * 设置登录用户
 * @param user 
 * @returns 
 */
export const setLoginUser = (user:User) =>
({
	type    : 'SET_LOGIN_USER',
	payload : user
});

/**
 * 设置登录用户
 * @param user 
 * @returns 
 */
 export const setJwt = (token:string) =>
 ({
	 type    : 'SET_JWT',
	 payload : {token}
 });

 export const logout = () =>
 ({
	type : 'LOGOUT',
	payload:null
 })

